/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ReportDefs from './defs.defs.js'

const $nsid = 'tools.ozone.report.assignModerator'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  reportId: /*#__PURE__*/ l.integer(),
  queueId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  did: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ format: 'did' })),
  isPermanent: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<ReportDefs.AssignmentView>(
    (() => ReportDefs.assignmentView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Assign a report to a user. Defaults to the caller. Admins may assign to any moderator. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'AlreadyAssigned',
  'InvalidAssignment',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
